import React, { useState } from "react";
import LogNav from "../layout/LoggedNav";
import MemberDetail from "../Billing/MemberDetail";
import axios from "axios";
import ENUMS from "../../utils/ENUMS.js";
import { useEffect } from "react";
import { BASE_URL } from "../../config.json";
import { getAuthData } from "../../services/authService";
import ClubTxnList from "../Billing/ClubTxnList";

const auth = getAuthData();

const token = localStorage.getItem(ENUMS.AUTH);

const Billing = () => {
  const [txnList, SetTxnsList] = useState([]);
  const [subscription, setSubscription] = useState(null);

  const fetchClubTxnList = () => {
    axios
      .get(`${BASE_URL}/club/txns/`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        SetTxnsList(res.data.data);
  console.log(res.data.data, "txnList from API");
        
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const fetCurrentSubscription = () => {
    axios
      .get(`${BASE_URL}/club/subscrption/`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        console.log(res, "RESPONSE", res);
        setSubscription(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    fetchClubTxnList();
    fetCurrentSubscription();
  }, []);

  return (
    <>
      <section className=" club_Login">
        <div className="page-width">
          <div className="billing-block gap-block-section">
            <h1 className="billing--title text-jost-sb-50">
            </h1>

            {/* <LogNav /> */}

            <div className="billing__wrap">
              <MemberDetail
                refreshList={fetCurrentSubscription}
                CurrentSubscription={subscription}
              />

              <ClubTxnList txnList={txnList} />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default Billing;
